<template>
  <div class="data-backup">
    <div class="page-header">
      <h2>数据备份</h2>
      <div class="header-actions">
        <el-button type="primary" :loading="creating" @click="handleCreate">
          <el-icon><plus /></el-icon>立即备份
        </el-button>
        <el-button @click="load" :loading="loading">刷新</el-button>
      </div>
    </div>

    <el-alert
      type="info"
      :closable="false"
      show-icon
      title="备份说明"
      description="系统每日凌晨2点自动备份数据库并上传云端；你也可以点击「立即备份」手动备份。点击「下载」可将备份文件保存到本地。备份文件保留30天。"
      style="margin-bottom:15px"
    />

    <!-- PC端表格 -->
    <el-table v-if="!isMobile" :data="tableData" border stripe style="width:100%" v-loading="loading">
      <el-table-column label="备份文件" min-width="260">
        <template #default="{row}">
          <el-icon style="vertical-align:middle;margin-right:6px"><document /></el-icon>{{ row.fileName }}
        </template>
      </el-table-column>
      <el-table-column label="类型" width="120">
        <template #default="{row}">
          <el-tag :type="tagType(row.tag)" size="small">{{ row.tagLabel }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="备份时间" width="180">
        <template #default="{row}">{{ row.timeLabel }}</template>
      </el-table-column>
      <el-table-column label="操作" width="120" fixed="right">
        <template #default="{row}">
          <el-button size="small" type="primary" :loading="downloading === row.key" @click="handleDownload(row)">
            <el-icon><download /></el-icon>下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 手机端卡片 -->
    <div v-else class="mobile-list">
      <div v-for="item in tableData" :key="item.key" class="backup-card">
        <div class="card-header">
          <el-icon><document /></el-icon>
          <el-tag :type="tagType(item.tag)" size="small">{{ item.tagLabel }}</el-tag>
        </div>
        <div class="card-file">{{ item.fileName }}</div>
        <div class="card-info"><span>备份时间：{{ item.timeLabel }}</span></div>
        <div class="card-actions">
          <el-button size="small" type="primary" :loading="downloading === item.key" @click="handleDownload(item)">下载</el-button>
        </div>
      </div>
      <el-empty v-if="!loading && tableData.length===0" description="暂无备份文件" />
    </div>
  </div>
</template>

<script src="@/assets/js/DataBackup.js"></script>

<style scoped>
.data-backup { padding: 20px; }
.page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px; flex-wrap: wrap; gap: 10px; }
.page-header h2 { margin: 0; font-size: 18px; }
.header-actions { display: flex; align-items: center; gap: 8px; }

/* 手机端卡片 */
.mobile-list { display: flex; flex-direction: column; gap: 10px; }
.backup-card { background: #fff; border-radius: 8px; padding: 14px; box-shadow: 0 1px 4px rgba(0,0,0,0.08); }
.card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
.card-file { font-size: 13px; word-break: break-all; color: #333; margin-bottom: 6px; }
.card-info { display: flex; flex-direction: column; gap: 4px; font-size: 13px; color: #666; margin-bottom: 10px; }
.card-actions { display: flex; gap: 8px; }

@media (max-width: 768px) {
  .data-backup { padding: 10px; }
  .page-header h2 { font-size: 16px; }
}
</style>
